module.exports = __webpack_public_path__ + "static/media/kohinarun.9316ff0e.md";